import React from "react";
import API from "../../../Utils/api";

const ProductCard = ({ product, onView, onEdit, onDelete, onRefresh }) => {
  const handleToggleTop = async () => {
    try {
      await API.put(`/product/toggle/${product._id}`);
      onRefresh();
    } catch (error) {
      console.error("Toggle error:", error);
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden group border border-gray-100">
      {/* Image */}
      <div className="relative h-48 overflow-hidden bg-gray-100">
        <img
          src={product.images?.[0]}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />

        {/* Top Product Badge */}
        <button
          onClick={handleToggleTop}
          title="Toggle Top Product"
          className={`absolute top-3 right-3 text-lg transition ${
            product.isTopProduct ? "opacity-100" : "opacity-40 hover:opacity-80"
          }`}
        >
          ⭐
        </button>

        {/* Category Badge */}
        <span className="absolute bottom-3 left-3 bg-green-600 text-white text-xs font-semibold px-2.5 py-1 rounded-full">
          {product.category?.category || "Uncategorized"}
        </span>
      </div>

      {/* Content */}
      <div className="p-4">
        <h3 className="text-base font-bold text-gray-800 truncate">
          {product.name}
        </h3>

        <div className="flex items-center justify-between mt-1">
          <span className="text-xs text-gray-400">Stock: {product.stock}</span>
        </div>

        <p className="text-xs text-gray-500 mt-2 line-clamp-2">
          {product.description}
        </p>

        {/* Pack Sizes */}
        {product.packSizes?.length > 0 && (
          <div className="flex flex-wrap gap-1 mt-3">
            {product.packSizes.map((size, i) => (
              <span
                key={i}
                className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full"
              >
                {size}
              </span>
            ))}
          </div>
        )}

        {/* Rating */}
        <div className="flex items-center gap-1 mt-2">
          <span className="text-yellow-400 text-sm">★</span>
          <span className="text-xs text-gray-600">
            {product.rating} ({product.reviewCount} reviews)
          </span>
        </div>

        {/* Actions */}
        <div className="flex gap-2 mt-4 pt-4 border-t border-gray-100">
          <button
            onClick={onView}
            className="flex-1 py-2 rounded-lg bg-gray-50 hover:bg-gray-100 text-gray-600 text-sm font-medium transition"
          >
            👁️ View
          </button>
          <button
            onClick={onEdit}
            className="flex-1 py-2 rounded-lg bg-blue-50 hover:bg-blue-100 text-blue-600 text-sm font-medium transition"
          >
            ✏️ Edit
          </button>
          <button
            onClick={onDelete}
            className="flex-1 py-2 rounded-lg bg-red-50 hover:bg-red-100 text-red-500 text-sm font-medium transition"
          >
            🗑️
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
